export enum CalendarViewMode {
  Day = 'day',
  Week = 'week',
  Month = 'month'
}
